// src/pages/tenant/MakePayment.jsx
import React, { useEffect, useState } from 'react';
import {
  Box, Button, Typography, Paper, Radio, RadioGroup,
  FormControlLabel, FormControl, TextField, MenuItem, Select, InputLabel
} from '@mui/material';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import { useNavigate } from 'react-router-dom';
import { getAuth } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import dayjs from 'dayjs';

export default function MakePayment() {
  const navigate = useNavigate();
  const [amountType, setAmountType] = useState('custom');
  const [amount, setAmount] = useState('');
  const [method, setMethod] = useState('card');
  const [date, setDate] = useState(new Date().toISOString().split('T')[0]);
  const [balance, setBalance] = useState(0);

  useEffect(() => {
    const auth = getAuth();
    const user = auth.currentUser;
    if (!user) return;

    const fetchBalance = async () => {
      const userDoc = await getDoc(doc(db, 'users', user.uid));
      if (userDoc.exists()) {
        const data = userDoc.data();
        setBalance(data.balance || 0);
      }
    };

    fetchBalance();
  }, []);

  const renderFeeNote = () => {
    if (method === 'card') return '3.5% service fee';
    if (method === 'bank') return '$3.50 service fee';
    return '';
  };

  const handleNext = () => {
    const paymentAmount = amountType === 'balance' ? balance : parseFloat(amount || 0);
    const fee = method === 'card'
      ? Number((paymentAmount * 0.035).toFixed(2))
      : 3.50;
    const total = method === 'card'
      ? Number((paymentAmount * 1.035).toFixed(2))
      : Number(paymentAmount + 3.50);

    navigate('/tenant/reviewPayment', {
      state: {
        paymentAmount,
        paymentMethod: method,
        formattedDate: dayjs(date).format('MMM D, YYYY'),
        fee,
        total,
      }
    });
  };

  return (
    <Box maxWidth="600px" mx="auto" my={5}>
      <Typography variant="h5" mb={2}>Make payment</Typography>
      <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
        <Typography fontWeight={600} mb={1}>Select an amount</Typography>
        <RadioGroup value={amountType} onChange={(e) => setAmountType(e.target.value)}>
          <FormControlLabel
            value="balance"
            control={<Radio />}
            label={`Current balance (as of ${new Date().toLocaleDateString()}) — $${balance.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
          />
          <FormControlLabel
            value="custom"
            control={<Radio />}
            label={
                            <TextField
                type="number"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                placeholder="0.00"
                size="small"
                sx={{ mt: 1 }}
                InputProps={{
                    startAdornment: (
                    <Box component="span" sx={{ mr: 0.5, fontWeight: 600 }}>$</Box>
                    )
                }}
                />
            }
          />
        </RadioGroup>

        <Box mt={4}>
          <Typography fontWeight={600} mb={1}>Select a payment method</Typography>
          <FormControl fullWidth>
            <InputLabel>Method</InputLabel>
            <Select
              value={method}
              label="Method"
              onChange={(e) => setMethod(e.target.value)}
            >
              <MenuItem value="card">
                <Box display="flex" alignItems="center" gap={1}>
                  <CreditCardIcon /> Credit card
                </Box>
              </MenuItem>
              <MenuItem value="bank">
                <Box display="flex" alignItems="center" gap={1}>
                  <AccountBalanceIcon /> Bank account
                </Box>
              </MenuItem>
            </Select>
          </FormControl>
          <Typography color="text.secondary" fontSize={13} mt={1}>
            {renderFeeNote()}
          </Typography>
        </Box>

        <Box mt={4}>
          <Typography fontWeight={600} mb={1}>Select a date</Typography>
          <TextField
            type="date"
            fullWidth
            value={date}
            onChange={(e) => setDate(e.target.value)}
          />
        </Box>

        <Box display="flex" gap={2} mt={5}>
          <Button
  fullWidth
  variant="contained"
  color="success"
  onClick={() => {
    const paymentAmount = amountType === 'balance' ? balance : Number(amount);
    const fee = method === 'card'
      ? Number((paymentAmount * 0.035).toFixed(2))
      : 3.50;
    const total = method === 'card'
      ? Number((paymentAmount * 1.035).toFixed(2))
      : paymentAmount + 3.50;

    navigate('/tenant/reviewPayment', {
      state: {
        paymentAmount,
        paymentMethod: method,
        formattedDate: new Date(date).toLocaleDateString('en-US', {
          month: 'short',
          day: 'numeric',
          year: 'numeric',
        }),
        fee,
        total
      }
    });
  }}
>
  Next
</Button>
          <Button fullWidth variant="outlined">Cancel</Button>
        </Box>
      </Paper>
    </Box>
  );
}